import { Enums } from '@bode-canada/core';
import { IconType } from '@/ui-kit/components/icon/enums';
import { OptionProperty } from '@/ui-kit/components/form/controls/components/select/enums';

export const PROPERTY_TYPE_OPTIONS = [
  {
    [OptionProperty.Value]: Enums.BuildingClassEnum.DETACHED,
    [OptionProperty.Label]: 'Detached House',
  },
  {
    [OptionProperty.Value]: Enums.BuildingClassEnum.ROW_TOWNHOUSE,
    [OptionProperty.Label]: 'Row / Townhouse',
  },
  {
    [OptionProperty.Value]: Enums.BuildingClassEnum.SEMI_DETACHED,
    [OptionProperty.Label]: 'Semi Detached House',
  },
  {
    [OptionProperty.Value]: Enums.BuildingTypeEnum.HIGH_RISE_APARTMENT,
    [OptionProperty.Label]: 'High Rise Apartment',
  },
  {
    [OptionProperty.Value]: Enums.BuildingTypeEnum.VACANT_LAND,
    [OptionProperty.Label]: 'Vacant Land',
  },
  {
    [OptionProperty.Value]: Enums.BuildingTypeEnum.LOW_RISE_APARTMENT,
    [OptionProperty.Label]: 'Low Rise Apartment',
  },
];

export const PROPERTY_TYPE_CARD_ICONS = {
  [Enums.BuildingClassEnum.DETACHED]: IconType.Detached,
  [Enums.BuildingClassEnum.ROW_TOWNHOUSE]: IconType.RowOrTownhouse,
  [Enums.BuildingClassEnum.SEMI_DETACHED]: IconType.SemiDetached,
  [Enums.BuildingTypeEnum.HIGH_RISE_APARTMENT]: IconType.HighRiseApartment,
  [Enums.BuildingClassEnum.VACANT_LAND]: IconType.VacantLand,
  [Enums.BuildingTypeEnum.LOW_RISE_APARTMENT]: IconType.LowRiseApartment,
};

export const BEDS_OPTIONS = [
  {
    [OptionProperty.Value]: null,
    [OptionProperty.Label]: 'Any',
  },
  {
    [OptionProperty.Value]: 0,
    [OptionProperty.Label]: 'Studio',
  },
  {
    [OptionProperty.Value]: 1,
    [OptionProperty.Label]: '1',
  },
  {
    [OptionProperty.Value]: 2,
    [OptionProperty.Label]: '2',
  },
  {
    [OptionProperty.Value]: 3,
    [OptionProperty.Label]: '3',
  },
  {
    [OptionProperty.Value]: 4,
    [OptionProperty.Label]: '4',
  },
  {
    [OptionProperty.Value]: 5,
    [OptionProperty.Label]: '5+',
  },
];

export const BATHS_OPTIONS = [
  {
    [OptionProperty.Value]: null,
    [OptionProperty.Label]: 'Any',
  },
  {
    [OptionProperty.Value]: 1,
    [OptionProperty.Label]: '1+',
  },
  {
    [OptionProperty.Value]: 1.5,
    [OptionProperty.Label]: '1.5+',
  },
  {
    [OptionProperty.Value]: 2,
    [OptionProperty.Label]: '2+',
  },
  {
    [OptionProperty.Value]: 2.5,
    [OptionProperty.Label]: '2.5+',
  },
  {
    [OptionProperty.Value]: 3,
    [OptionProperty.Label]: '3+',
  },
  {
    [OptionProperty.Value]: 4,
    [OptionProperty.Label]: '4+',
  },
];

export const PARKING_SPACES_OPTIONS = [
  {
    [OptionProperty.Value]: null,
    [OptionProperty.Label]: 'Any',
  },
  {
    [OptionProperty.Value]: 1,
    [OptionProperty.Label]: '1+',
  },
  {
    [OptionProperty.Value]: 2,
    [OptionProperty.Label]: '2+',
  },
  {
    [OptionProperty.Value]: 3,
    [OptionProperty.Label]: '3+',
  },
  {
    [OptionProperty.Value]: 4,
    [OptionProperty.Label]: '4+',
  },
  {
    [OptionProperty.Value]: 5,
    [OptionProperty.Label]: '5+',
  },
];

export const GARAGE_SPACES_OPTIONS = [
  {
    [OptionProperty.Value]: null,
    [OptionProperty.Label]: 'Any',
  },
  {
    [OptionProperty.Value]: 1,
    [OptionProperty.Label]: '1+',
  },
  {
    [OptionProperty.Value]: 2,
    [OptionProperty.Label]: '2+',
  },
  {
    [OptionProperty.Value]: 3,
    [OptionProperty.Label]: '3+',
  },
  {
    [OptionProperty.Value]: 4,
    [OptionProperty.Label]: '4+',
  },
];

export const TENANT_STATUSES = [Enums.OccupancyEnum.TENANT];

export const NO_TENANT_STATUSES = [
  Enums.OccupancyEnum.VACANT,
  Enums.OccupancyEnum.NEW_NEVER_OCCUPIED,
  Enums.OccupancyEnum.FLEXIBLE,
  Enums.OccupancyEnum.SELLER,
  Enums.OccupancyEnum.OWNER,
];

export const BEDS_MASTER_BUTTON_INDEX = 0;
export const BATHS_MASTER_BUTTON_INDEX = 0;
export const PARKING_SPACES_MASTER_BUTTON_INDEX = 0;
export const GARAGE_SPACES_MASTER_BUTTON_INDEX = 0;
export const LISTING_TYPE_TOOLTIP_MESSAGE = 'MLS listings are represented by Agents. Bõde listings are represented by sellers themselves.';
